import { render, staticRenderFns } from "./typeconfig.vue?vue&type=template&id=ff2602de"
import script from "./typeconfig.vue?vue&type=script&lang=js"
export * from "./typeconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports